// 📄 components/StepActivation.tsx
import React from 'react'; 

export function StepActivation() {
  return (
    <div className="space-y-4">
      <h3 className="text-lg font-medium text-blue-400">4. Activación de Canales de Documentación</h3>
      <p className="text-sm text-gray-400">Activa los triggers globales para que el programa de extracción reconozca los flujos comerciales.</p>
      <div className="space-y-2 pt-2">
        <label className="flex items-center gap-3 bg-white/5 p-3 rounded-lg border border-white/5 cursor-pointer hover:bg-white/10 transition-all">
          <input type="checkbox" className="rounded bg-zinc-800 border-white/10 text-blue-500 focus:ring-0" />
          <span className="text-sm">Habilitar eventos automáticos para Órdenes de Compra (Direct Procurement)</span>
        </label>
      </div>
    </div>
  );
}